import type { LayoutLoad } from './$types';
import { resolveCountries } from '$lib/utils/loadCountriesResult';

export const ssr = false;
export const prerender = false;

/**
 * Loads the authorized countries without throwing on non-auth failures. A throw
 * here would leave the SPA boot loader lingering (the root layout component
 * never mounts to tear it down). Instead we classify the outcome and let
 * +layout.svelte render a branded error state (with retry) or hold the loader
 * while an auth redirect completes.
 */
export const load: LayoutLoad = async () => {
  const result = await resolveCountries();

  if (result.status === 'ok') {
    return { countries: result.countries, loadError: null, authRedirecting: false };
  }

  if (result.status === 'auth-redirect') {
    return { countries: [] as string[], loadError: null, authRedirecting: true };
  }

  return { countries: [] as string[], loadError: result.message, authRedirecting: false };
};
